import { useEffect, useState } from 'react';
import AddAddressPopup from './add-address/add-address';
import { FaCheckCircle, FaInfoCircle, FaMapMarkerAlt, FaStore, FaTruck, FaClone } from 'react-icons/fa';
import './style.scss';
import { AuthState, MyCartState } from 'src/store';
import { useTypedSelector } from 'src/store/hooks';
import { CostInfoProps } from '../mycart.interface';
import { isEmpty } from 'lodash';
import { getQuotation } from 'src/lib/order/orderData';
import { Users } from 'src/lib/users/users';

interface DeliveryInfoProps {
  isStorePickup: boolean;
  onStorePickup: (v: boolean) => void;
  getOrderCost: (v: CostInfoProps) => void;
  business: Record<string, any>;
  businessDetails: Record<string, any>;
  getDeliveryAddress: (v: Record<string, any> | undefined) => void;
  getOrderError: (v: Record<string, any> | undefined) => void;
}
const STATIC_STORE_ADDRESS = {
  name: "Sommlike",
  fullAddress: "407 Main Street, Ridgefield, CT 06877",
  city: "Ridgefield",
  state: "CT",
  zip: "06877",
  pin: "06877",
  latitude: "41.2828",
  longitude: "-73.4984",
  phoneNumber: "203-403-2003"
};
export const DeliveryInfo = (props: DeliveryInfoProps) => {
  const authState: AuthState = useTypedSelector((state) => state.auth);
  const myCartState: MyCartState = useTypedSelector((state) => state.order);
  const items: any = isEmpty(myCartState.collection) ? [] : myCartState.collection.items;
  const users = new Users();
  const [showAddAddress, setShowAddAddress] = useState(false);
  const [deliveryAddresses, setDeliveryAddresses] = useState<any[]>([]);
  const [seletedDeliveryAddressIndex, setSeletedDeliveryAddressIndex] = useState<number>();
  const [error, setIsError] = useState<Record<string, any>>();
  const [alertMsg, setAlertMsg] = useState<string>();
  const [pickupPhone, setPickupPhone] = useState(authState.currentUser.contactNumber || '');
  const storeAddress = STATIC_STORE_ADDRESS;

  const handleCopyClick = async (fullAddress: string) => {
    try {
      await navigator.clipboard.writeText(fullAddress);
      setAlertMsg('Address copied to clipboard');
    } catch (err) {
      console.error('Failed to copy text: ', err);
      setAlertMsg(undefined);
    }
    setTimeout(() => {
      setAlertMsg(undefined);
    }, 2000);
  };

  const handlePickupPhoneChange = (val: string) => {
    setPickupPhone(val);
    if (storeAddress) {
      props.getDeliveryAddress({
        address: storeAddress,
        contactDetails: { contactNumber: val }
      });
    }
  };

  const handleTabChange = (isPickup: boolean) => {
    props.onStorePickup(isPickup);
    if (isPickup) {
      setSeletedDeliveryAddressIndex(undefined);
      if (storeAddress) {
        getOrderQuotation(storeAddress);
        props.getDeliveryAddress({
          address: storeAddress,
          contactDetails: { contactNumber: pickupPhone || authState.currentUser.contactNumber || '' }
        });
      }
    } else {
      props.getDeliveryAddress(undefined);
      props.getOrderError(undefined);
      setIsError(undefined);
      if (seletedDeliveryAddressIndex !== undefined && deliveryAddresses[seletedDeliveryAddressIndex]) {
        const address = deliveryAddresses[seletedDeliveryAddressIndex];
        const contactNumber = (address.contactDetails && address.contactDetails?.contactNumber) || '';
        onChangeSavedAddress(address, seletedDeliveryAddressIndex, contactNumber);
      } else {
        getOrderTotal();
      }
    }
  };

  const onChangeSavedAddress = (deliveryAddress: Record<string, any>, index: number, contactNumber: string) => {
    setSeletedDeliveryAddressIndex(index);
    getOrderQuotation(deliveryAddress);
    props.getDeliveryAddress(deliveryAddress);
  };

  useEffect(() => {
    loadUserAddress();
    if (props.isStorePickup && storeAddress) {
      getOrderQuotation(storeAddress);
      props.getDeliveryAddress({
        address: storeAddress,
        contactDetails: { contactNumber: pickupPhone || authState.currentUser.contactNumber || '' }
      });
    }
  }, []);

  const loadUserAddress = async () => {
    const userAddress = await users.getUserAddressByUserId(authState.currentUser._id);
    if (userAddress) {
      const { savedAddress } = userAddress;
      setDeliveryAddresses(savedAddress || []);
    }
  };

  // const hanldeStorePickup = (v: boolean) => {
  //   setSeletedDeliveryAddressIndex(undefined);
  //   // setStorePickup(v);
  //   props.onStorePickup(v);
  //   if (v) {
  //     const storeAddress = props.business.businessAddress;
  //     getOrderQuotation(storeAddress);
  //     props.getDeliveryAddress({ address: storeAddress });
  //   } else {
  //     props.getDeliveryAddress(undefined);
  //     getOrderTotal();
  //   }
  // };

  const getOrderQuotation = async (address: Record<string, any>) => {
    setIsError(undefined);
    const deliveryAddress = address?.address ? address.address : address;
    const addressData = {
      phoneNumber: deliveryAddress?.phoneNumber,
      addressLine1: deliveryAddress?.fullAddress,
      addressLine2: deliveryAddress?.fullAddress,
      city: deliveryAddress?.city,
      state: deliveryAddress?.state,
      latitude: deliveryAddress?.latitude ? deliveryAddress.latitude : '',
      longitude: deliveryAddress?.longitude ? deliveryAddress.longitude : '',
      pin: deliveryAddress?.zip ? deliveryAddress?.zip : deliveryAddress?.pin,
    };
    let userOrder = {};
    userOrder = { address: { dropAddress: addressData }, payment: { method: 'CARD' } };

    if (!isEmpty(props.businessDetails)) {
      userOrder = { ...userOrder, event: { businessDetails: props.businessDetails } };
    }

    const reqData = {
      items: items,
      order: userOrder,
    };

    const response = await getQuotation(reqData);
    if (response.status == 1) {
      if (response.result.order.actualAmount != 0) {
        props.getOrderError(undefined);
        const quotationResponse = response.result.order;
        const costInfo: CostInfoProps = {
          orderSubTotal: { label: 'Order Total', value: quotationResponse.actualAmountLabel },
          orderTotal: { label: 'Total', value: quotationResponse.totalAmountLabel },
          totalAddOnCost: { label: 'Taxes', value: quotationResponse.totalAddOnCost.taxesLabel },
          shippingTotal: { label: 'Delivery Fee', value: quotationResponse.totalAddOnCost.shippingLabel },
        };
        props.getOrderCost(costInfo);
      } else {
        getOrderTotal();
        props.getOrderError({ isError: true, errorMessage: 'Selected address is not serviceable' });
        setIsError({ isError: true, errorMessage: 'Selected address is not serviceable' });
      }
    } else {
      getOrderTotal();
      if (response.error.errorCode === 400001 || response.error.errorCode === 400007) {
        props.getOrderError({
          isError: true,
          errorMessage: `We do not deliver to your area yet, but please email us at hello@sommlike.com—we might be able to accommodate your request as an exception.`,
          errorCode: response.error.errorCode,
        });
        setIsError({
          isError: true,
          errorMessage: `We do not deliver to your area yet, but please email us at hello@sommlike.com—we might be able to accommodate your request as an exception.`,
          errorCode: response.error.errorCode,
        });
      } else if (response.error.errorCode === 400008) {
        props.getOrderError({
          isError: true,
          errorMessage: response?.error?.errorMessage,
          errorCode: response.error.errorCode,
        });
        setIsError({ isError: true, errorMessage: response?.error?.errorMessage, errorCode: response.error.errorCode });
      } else {
        if (deliveryAddress?.zip !== "06877") {
          props.getOrderError({
            isError: true,
            errorMessage: `We do not deliver to your area yet, but please email us at hello@sommlike.com—we might be able to accommodate your request as an exception.`,
            errorCode: response.error.errorCode,
          });
          setIsError({
            isError: true,
            errorMessage: `We do not deliver to your area yet, but please email us at hello@sommlike.com—we might be able to accommodate your request as an exception.`,
            errorCode: response.error.errorCode,
          });
        } else {
          props.getOrderError({
            isError: true,
            errorMessage: response?.error?.errorMessage,
            errorCode: response.error.errorCode,
          });
          setIsError({ isError: true, errorMessage: response?.error?.errorMessage, errorCode: response.error.errorCode });
        }
      }
    }
  };

  const getOrderTotal = () => {
    let sum = 0;
    // if (items) {
    for (const num of items) {
      const value = num.quantity * Number(num.price);
      sum = sum + value;
      sum = Math.round(sum * 100) / 100;
    }
    const orderCost: CostInfoProps = {
      orderSubTotal: { label: 'Order Total', value: '$' + sum },
      orderTotal: { label: 'Total', value: '$' + sum },
    };
    props.getOrderCost(orderCost);
  };

  // const [isCopied, setIsCopied] = useState(false);
  // const handleCopyClick = async (fullAddress: string) => {
  //   try {
  //     await navigator.clipboard.writeText(fullAddress);
  //     setAlertMsg('Address copied to clipboard');
  //   } catch (err) {
  //     console.error('Failed to copy text: ', err);
  //     setAlertMsg(undefined);
  //   }
  //   setTimeout(() => {
  //     setAlertMsg(undefined);
  //   }, 2000);
  // };

  const handleAfterAddressAdded = (v: Record<string, any>) => {
    setAlertMsg('Delivery address added successfully.');
    loadUserAddress();
    setTimeout(() => {
      setAlertMsg(undefined);
    }, 2000);
  };

  return (
    <div className="delivery-info-container">
      {storeAddress && (
        <div className="delivery-method-tabs mb-4">
          <button
            type="button"
            className={`tab-btn ${!props.isStorePickup ? 'active' : ''}`}
            onClick={() => handleTabChange(false)}
          >
            <FaTruck size={16} /> Delivery
          </button>
          <button
            type="button"
            className={`tab-btn ${props.isStorePickup ? 'active' : ''}`}
            onClick={() => handleTabChange(true)}
          >
            <FaStore size={16} /> Store Pickup
          </button>
        </div>
      )}

      {error && error.isError && (
        <div
          className="d-flex justify-content-between card_address mt-4 small"
          style={{ background: '#fff1ec', border: '1px solid #ff5722' }}
        >
          <div style={{ color: '#000000' }}>
            <FaInfoCircle size={15} />
            &nbsp; {error.errorMessage}
          </div>
        </div>
      )}
      {alertMsg && (
        <div
          className="d-flex justify-content-between card_address mt-4 small"
          style={{ background: '#d3ffd5', border: '1px solid #ff5722' }}
        >
          <div style={{ color: '#000000' }}>
            <FaCheckCircle size={15} />
            &nbsp; {alertMsg}
          </div>
        </div>
      )}

      {props.isStorePickup && storeAddress && (
        <div className="card_address bg-light mt-4 p-4 d-flex flex-column" style={{ cursor: 'default' }}>
          <div className="d-flex align-items-center mb-3">
            <FaStore size={20} color="#b25661" />
            <h5 className="m-0 pl-2 font-weight-bold" style={{ color: '#b25661', fontSize: 18 }}>Pickup Location</h5>
          </div>
          <div className="pl-0 small">
            <h6 className="font-weight-bold mb-1" style={{ fontSize: 16 }}>{storeAddress.name}</h6>
            <p className="text-muted mb-2" style={{ fontSize: 14 }}>{storeAddress.fullAddress}</p>
            <span
              style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '4px', color: '#b25661', fontWeight: 500 }}
              onClick={() => handleCopyClick(storeAddress.fullAddress)}
              title={'Copy Address'}
            >
              <FaClone color={'#b25661'} /> Copy Address
            </span>
          </div>

          <div className="mt-4">
            <h6 className="font-weight-bold mb-2" style={{ fontSize: 15 }}>Contact Number for Pickup Notifications</h6>
            <div className="d-flex flex-column">
              <span className="text-muted small mb-2">We will send updates about your pickup status to this number:</span>
              <input
                type="text"
                className="form-control"
                style={{ maxWidth: '300px', borderColor: '#dee2e6' }}
                value={pickupPhone || ''}
                onChange={(e) => handlePickupPhoneChange(e.target.value)}
                placeholder="Enter contact number"
              />
            </div>
          </div>
        </div>
      )}

      {!props.isStorePickup && (
        <div className=" mt-4">
          <div className="d-flex flex-column">
            <div className="d-flex justify-content-between ">
              <div className="cart__title">
                <FaMapMarkerAlt />
                &nbsp;Delivery Address
              </div>
              {deliveryAddresses!.length > 0 && (
                <div className="cart__title_add_address" onClick={() => setShowAddAddress(!showAddAddress)}>
                  +Add New
                </div>
              )}
            </div>
          </div>
          <div className="col-12 mt-3 p-0">
            {deliveryAddresses!.length > 0 &&
              deliveryAddresses!.map((address: Record<string, any>, index: number) => {
                const userAddress = address?.address;
                const contactNumber = (address.contactDetails && address.contactDetails?.contactNumber) || '';
                const splitAddress = (userAddress && userAddress?.fullAddress) || '';

                return (
                  <label htmlFor={index + 'savedAddress'} className="w-100" key={index}>
                    <div
                      className="d-flex flex-row mb-2 card_address"
                      style={{ border: seletedDeliveryAddressIndex === index ? '1px solid #b25661' : '' }}
                    >
                      <div>
                        <input
                          id={index + 'savedAddress'}
                          name="savedAddress"
                          type="radio"
                          style={{ height: 'auto', accentColor: '#b25661' }}
                          onChange={() => onChangeSavedAddress(address, index, contactNumber)}
                          checked={seletedDeliveryAddressIndex === index}
                        />
                      </div>
                      <div className="pl-3 d-flex flex-column ">
                        <p className="address_font_size_tilte">
                          <strong>{userAddress.customData?.name || authState.currentUser.name}</strong>
                        </p>
                        <span className="m-0 address_font_size">{splitAddress}</span>
                        <span className="m-0 address_font_size">
                          {userAddress.city}, {userAddress.state}, {userAddress.country}, {userAddress.zip}
                        </span>

                        <span className="pt-2 address_font_size">
                          <b>Contact Number:</b> {contactNumber}
                        </span>
                        {seletedDeliveryAddressIndex === index && error && error?.isError && (
                          <div style={{ color: '#ff5722' }} className="pt-4">
                            <div>{error.errorMessage}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </label>
                );
              })}
            {deliveryAddresses!.length === 0 && (
              <div className="col-12 col-md-6 p-0">
                <div className="cart__title_add_address card_address" onClick={() => setShowAddAddress(!showAddAddress)}>
                  + Add Delivery Address
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      <AddAddressPopup
        isOpen={showAddAddress}
        onCloseAddAddressPopup={() => setShowAddAddress(false)}
        addressType="savedAddress"
        onAddressAdded={handleAfterAddressAdded}
        savedAddress={deliveryAddresses}
      />
    </div>
  );
};
